import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SubscribedAppsComponent } from './lib/subscribed-apps/subscribed-apps.component'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { UtilityLibraryModule } from '@tokeet-frontend/utility'

@NgModule({
  imports: [CommonModule, Tv3PlatformModule, UtilityLibraryModule, MatSlideToggleModule],
  declarations: [SubscribedAppsComponent],
  exports: [SubscribedAppsComponent],
})
export class BillingLibModule {}
